// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.CompactValueStats_card__2qdbV {
  width: 122px;
  padding: 10px 9px;
  border: 1px solid #d8e0e5;
  border-radius: 8px;
  background: rgba(255, 255, 255, 0.98);
  box-shadow: 0 6px 18px rgba(26, 54, 72, 0.2);
  color: #17384c;
}

.CompactValueStats_title__zj-mf {
  display: block;
  margin-bottom: 9px;
  font-size: 10px;
  line-height: 1.1;
  text-align: center;
  text-transform: uppercase;
  letter-spacing: 0.02em;
}

.CompactValueStats_grid__JkqO- {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 9px 8px;
}

.CompactValueStats_metric__GBE6H {
  min-width: 0;
  text-align: center;
}

.CompactValueStats_iconBox__dfKM5 {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 36px;
  height: 36px;
  margin: 0 auto 4px;
  border: 1px solid currentColor;
  border-radius: 9px;
  background: color-mix(in srgb, currentColor 10%, white);
}

.CompactValueStats_iconBox__dfKM5 img {
  width: 25px;
  height: 25px;
}

.CompactValueStats_progressTrack__6170b {
  width: 40px;
  height: 5px;
  margin: 0 auto 4px;
  overflow: hidden;
  border-radius: 999px;
  background: #e8eaec;
}

.CompactValueStats_progressTrack__6170b span {
  display: block;
  height: 100%;
  border-radius: inherit;
  background: currentColor;
}

.CompactValueStats_percentage__3RdUY {
  display: block;
  color: #243746;
  font-size: 10px;
  font-weight: 700;
  line-height: 1;
}

.CompactValueStats_bienveillance__k1Rny {
  color: var(--upcare-value-bienveillance, #fed14c);
}

.CompactValueStats_engagement__DzX1N {
  color: var(--upcare-value-engagement, #2894d2);
}

.CompactValueStats_faireEquipe__a\\+7yI {
  color: var(--upcare-value-faire-equipe, #e71873);
}

.CompactValueStats_respect__GXL5C {
  color: var(--upcare-value-respect, #2fac68);
}

@media (max-width: 760px) {
  .CompactValueStats_card__2qdbV {
    width: 108px;
    padding: 8px 7px;
  }

  .CompactValueStats_iconBox__dfKM5 {
    width: 32px;
    height: 32px;
  }

  .CompactValueStats_iconBox__dfKM5 img {
    width: 22px;
    height: 22px;
  }

  .CompactValueStats_progressTrack__6170b {
    width: 34px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/Overview/CompactValueStats.module.css"],"names":[],"mappings":"AAAA;EACE,YAAY;EACZ,iBAAiB;EACjB,yBAAyB;EACzB,kBAAkB;EAClB,qCAAqC;EACrC,4CAA4C;EAC5C,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,qCAAqC;EACrC,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,8BAA8B;EAC9B,kBAAkB;EAClB,uDAAuD;AACzD;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,WAAW;EACX,WAAW;EACX,kBAAkB;EAClB,gBAAgB;EAChB,oBAAoB;EACpB,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,YAAY;EACZ,sBAAsB;EACtB,wBAAwB;AAC1B;;AAEA;EACE,cAAc;EACd,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,iDAAiD;AACnD;;AAEA;EACE,8CAA8C;AAChD;;AAEA;EACE,gDAAgD;AAClD;;AAEA;EACE,2CAA2C;AAC7C;;AAEA;EACE;IACE,YAAY;IACZ,gBAAgB;EAClB;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,WAAW;EACb;AACF","sourcesContent":[".card {\n  width: 122px;\n  padding: 10px 9px;\n  border: 1px solid #d8e0e5;\n  border-radius: 8px;\n  background: rgba(255, 255, 255, 0.98);\n  box-shadow: 0 6px 18px rgba(26, 54, 72, 0.2);\n  color: #17384c;\n}\n\n.title {\n  display: block;\n  margin-bottom: 9px;\n  font-size: 10px;\n  line-height: 1.1;\n  text-align: center;\n  text-transform: uppercase;\n  letter-spacing: 0.02em;\n}\n\n.grid {\n  display: grid;\n  grid-template-columns: repeat(2, 1fr);\n  gap: 9px 8px;\n}\n\n.metric {\n  min-width: 0;\n  text-align: center;\n}\n\n.iconBox {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 36px;\n  height: 36px;\n  margin: 0 auto 4px;\n  border: 1px solid currentColor;\n  border-radius: 9px;\n  background: color-mix(in srgb, currentColor 10%, white);\n}\n\n.iconBox img {\n  width: 25px;\n  height: 25px;\n}\n\n.progressTrack {\n  width: 40px;\n  height: 5px;\n  margin: 0 auto 4px;\n  overflow: hidden;\n  border-radius: 999px;\n  background: #e8eaec;\n}\n\n.progressTrack span {\n  display: block;\n  height: 100%;\n  border-radius: inherit;\n  background: currentColor;\n}\n\n.percentage {\n  display: block;\n  color: #243746;\n  font-size: 10px;\n  font-weight: 700;\n  line-height: 1;\n}\n\n.bienveillance {\n  color: var(--upcare-value-bienveillance, #fed14c);\n}\n\n.engagement {\n  color: var(--upcare-value-engagement, #2894d2);\n}\n\n.faireEquipe {\n  color: var(--upcare-value-faire-equipe, #e71873);\n}\n\n.respect {\n  color: var(--upcare-value-respect, #2fac68);\n}\n\n@media (max-width: 760px) {\n  .card {\n    width: 108px;\n    padding: 8px 7px;\n  }\n\n  .iconBox {\n    width: 32px;\n    height: 32px;\n  }\n\n  .iconBox img {\n    width: 22px;\n    height: 22px;\n  }\n\n  .progressTrack {\n    width: 34px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"card": `CompactValueStats_card__2qdbV`,
	"title": `CompactValueStats_title__zj-mf`,
	"grid": `CompactValueStats_grid__JkqO-`,
	"metric": `CompactValueStats_metric__GBE6H`,
	"iconBox": `CompactValueStats_iconBox__dfKM5`,
	"progressTrack": `CompactValueStats_progressTrack__6170b`,
	"percentage": `CompactValueStats_percentage__3RdUY`,
	"bienveillance": `CompactValueStats_bienveillance__k1Rny`,
	"engagement": `CompactValueStats_engagement__DzX1N`,
	"faireEquipe": `CompactValueStats_faireEquipe__a+7yI`,
	"respect": `CompactValueStats_respect__GXL5C`
};
export default ___CSS_LOADER_EXPORT___;
